import script from "./basicDatas.vue?vue&type=script&setup=true&lang=js"
export * from "./basicDatas.vue?vue&type=script&setup=true&lang=js"

import "./basicDatas.vue?vue&type=style&index=0&id=691b413b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-691b413b"]])

export default __exports__